import Lockr from 'lockr';

import Vue from 'vue';

if (process.env.NODE_ENV === 'development') {
  Lockr.prefix = 'lockr_model_dev_';
} else {
  Lockr.prefix = 'lockr_model_';
}

export default {
  setUserinfo (state, userinfo) {
    state.userinfo = userinfo;
    Lockr.set('userinfo', userinfo);
  },
  setMessage (state, message) {
    state.admin.loginMessage = message;
  },
  clearUserInfo (state) {
    Vue.set(state, 'userinfo', {username: ''});
    Lockr.set('userinfo', null);
    console.log(Lockr.get('userinfo'));
  },
  setCanteenList (state, canteenList) {
    state.global.canteenList = canteenList;
    // state.filterWrapper.listQuery.canteen = state.global.canteenList[0];
  },
  setEateryList (state, eateryList) {
    state.global.eateryList = eateryList;
    state.filterWrapper.listQuery.eatery = state.global.eateryList[0];
  },
  setMachineList (state, machineList) {
    state.global.machineList = machineList;
    state.filterWrapper.listQuery.machine = state.global.machineList[0];
  },
  setListQuery (state, listQuery) {
    state.filterWrapper.listQuery = listQuery;
  },
  setModelList (state, modelList) {
    state.modelList = modelList;
  },
  emitLoading (state, duration = 0) {
    state.fullscreenLoading = true;
    if (duration) {
      setTimeout(() => {
        state.fullscreenLoading = false;
      }, duration);
    }
  },
  removeLoading (state, delay = 0) {
    setTimeout(() => {
      state.fullscreenLoading = false;
    }, delay);
  },
  setBatchList (state, batchList) {
    console.log(batchList);
    state.batchList = batchList;
  },
  setMarkImageList (state, imageList) {
    state.markImageList = imageList;
  },
  markImage (state, {index, class_id}) {
    console.log(index);
    console.log(state.markImageList);
    Vue.set(state.markImageList[index], 'class_id', class_id);
    // Lockr.set('markImageList', state.markImageList);
  },
  mark (state, {dish_img_uuid, class_id}) {
    let _class = this.$_.find(state.markImageList, {dish_img_uuid});
    Vue.set(_class, 'class_id', class_id);
    let count = state.markedCount[class_id] ? state.markedCount[class_id] : 0;
    count++;
    console.log(count);
    Vue.set(state.markedCount, class_id, count);
  },
  unMark (state, {dish_img_uuid, class_id}) {
    let _class = this.$_.find(state.markedImageList, {dish_img_uuid});
    Vue.set(_class, 'class_id', '');
    let count = state.markedCount[class_id] ? state.markedCount[class_id] : 0;
    count--;
    Vue.set(state.markedCount, class_id, count);
  },
  delete (state, dish_img_uuid) {
    let _class = this.$_.find(state.markImageList, {dish_img_uuid});
    Vue.set(_class, 'class_id', '-1');
  },
  changeCurrentDishModelIndex (state, value) {
    state.currentDishModelIndex += value;
  },
  setAllClassList (state, classList) {
    state.allClassList = classList;
  },
  setBatchImageList (state, batchImageList) {
    state.markImageList = batchImageList;
  },
  setBatchTag (state, batchTag) {
    state.batchTag = batchTag;
  },
  setUncheckedDishList (state, uncheckedDishList) {
    state.uncheckedDishList = uncheckedDishList;
  },
  setSubTitle (state, subtitle) {
    state.subtitle = subtitle;
  },
  updateList (state, value) {
    console.log(value);
  },
  setUnMarkedImageList (state, value) {
    state.unMarkedImageList = value;
  },
  setMarkedImageList (state, value) {
    state.markedImageList = value;
  },
  addCheckTextObj (state, obj) {
    let idx = this.$_.findIndex(state.checkTextObjList, function (o) {
      return o.dish_img_uuid === obj.dish_img_uuid;
    });
    if (idx === -1) {
      if (!obj.check_text) {
        return;
      }
      state.checkTextObjList.push(obj);
    } else {
      if (!obj.check_text) {
        state.checkTextObjList.splice(idx, 1);
      } else {
        state.checkTextObjList[idx] = obj;
      }
    }
  },
  clearCheckTextObj (state) {
    state.checkTextObjList = [];
  },
  toggleSubMenu (state, show) {
    state.subMenuShow = show;
  },
  setAllCanteenList (state, canteenList) {
    state.allCanteenList = canteenList;
  },
  setTaskFormData (state, taskFormData) {
    state.taskFormData = taskFormData;
  },
  getDetectedUnCheckRemindList (state, list) {
    list.forEach(a => {
      Vue.set(a, 'type', 'detected');
    });
    state.detectedUnCheckList = list;
  },
  getBackDataUnCheckRemindList (state, list) {
    list.forEach(a => {
      Vue.set(a, 'type', 'backData');
    });
    state.backDataUnCheckList = list;
  },
  getDataCollectCheckRemind (state, list) {
    list.forEach(a => {
      Vue.set(a, 'type', 'unmark');
    });
    state.dataCollectCheckRemindList = list;
  },
  setAllImageList (state, list) {
    state.allImageList = list;
  },
  // 储存正在审查的任务UUID
  setTaskUuid (state, uuid) {
    console.log(uuid);
    state.taskUuid = uuid;
  },
  setCurrentCheckTaskInfo (state, info) {
    state.currentCheckTaskInfo = info;
  },
  addToDownloadImageList (state, imageUrl) {
    state.downLoadImageList.push(imageUrl);
  },
  clearImages (state, imageUrl) {
    Vue.set(state, 'downLoadImageList', []);
  },
  setShowTest (state, val) {
    // this.showTest = val
    state.showTest = val;
  },
  cachedDishList (state, dishList) {
    state.cachedDishList = dishList;
  },
  setActiveTab (state, activeTable) {
    state.activeTable = activeTable;
  },
  setCheckingTaskUUid (state, checkingTaskUUID) {
    state.checkingTaskUUID = checkingTaskUUID;
  },
  removeCheckingTaskUUid (state) {
    // let index = this.$_.findIndex(state.checkingTaskUUID, (a) => a === checkingTaskUUID);
    // index !== -1 && .slice(index, 1);
    state.checkingTaskUUID = '';
  },
  setTaskUUIDForTrainList (state, {idx, list}) {
      // state.taskUUIDForTrain[idx] = list;
    Vue.set(state.taskUUIDForTrain, idx, list);
  },
  resetTaskUUIDForTrainList (state) {
    state.taskUUIDForTrain = [[], []];
  },
  setCheckRegionData (state, data) {
    state.checkRegionData = data;
  },
  setPremarkData (state, data) {
    state.premarkData = data;
  },
  setStandardRegionModel (state, model) {
    state.standardRegionModel = model;
  },
  setLabelTaskId (state, label_task_id) {
    state.label_task_id = label_task_id;
  },
  setAllMachineList (state, allMachineList) {
    state.allMachineList = allMachineList;
  },
  setCustomMachineList (state, machine_info_list) {
    state.customMachineList = machine_info_list;
  },
  set_api_version_list (state, version_list) {
    state.api_version_list = version_list;
  },
  TOGGLE_SIDEBAR (state) {
    state.sideBarFold = !state.sideBarFold;
  },
  SET_ALL_CATEGORY_LIST (state, category_list) {
    state.category_list = category_list
  }
};
